import { ITelemetryItem } from '@microsoft/applicationinsights-web';

const REDACTED_DOMAINS = [/\.blob\.core\.windows\.net$/i];

const isRedactedDomain = (host: string) =>
  REDACTED_DOMAINS.some(pattern => pattern.test(host));

const stripQueryString = (url: string): string => {
  try {
    const parsed = new URL(url);
    if (isRedactedDomain(parsed.hostname)) {
      return `${parsed.origin}${parsed.pathname}`;
    }
    return url;
  } catch {
    return url;
  }
};

/**
 * Strips the Azure Blob Storage SAS token (a query string) from any
 * auto-collected dependency telemetry before it leaves the browser.
 * `correlationHeaderExcludedDomains` only stops a correlation header being
 * attached to Blob requests — it does not stop the SDK's ajax/fetch
 * auto-collection from capturing the full request URL, which is where the
 * SAS token actually lives.
 */
export const redactSensitiveUrls = (item: ITelemetryItem): boolean | void => {
  const baseData = item.baseData as
    | { name?: string; target?: string; data?: string }
    | undefined;

  if (!baseData) {
    return true;
  }

  if (typeof baseData.target === 'string') {
    baseData.target = stripQueryString(baseData.target);
  }
  if (typeof baseData.data === 'string') {
    baseData.data = stripQueryString(baseData.data);
  }
  if (typeof baseData.name === 'string') {
    baseData.name = stripQueryString(baseData.name);
  }

  return true;
};
